import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var ClassService = /** @class */ (function () {
    function ClassService(http) {
        this.http = http;
        this.cls = {};
    }
    ClassService.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.http.get('app/app/json/class.json')
                .subscribe(function (json) {
                _this.getClassJson(json);
                resolve();
            });
        });
    };
    ClassService.prototype.getClassJson = function (json, path) {
        if (path === void 0) { path = ''; }
        for (var _i = 0, _a = Object.keys(json); _i < _a.length; _i++) {
            var key = _a[_i];
            var data = json[key];
            var p = path ? path + '.' + key : key;
            if (typeof data === 'string' || data instanceof Array) {
                this.cls[p] = data;
            }
            else if (Object.prototype.toString.call(data) === '[object Object]') {
                this.getClassJson(data, p);
            }
        }
    };
    ClassService.prototype.getClass = function (key, path) {
        if (key === 'list') {
            key = 'form';
        }
        return this.cls[key + '.' + path] || '';
    };
    ClassService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ClassService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return ClassService;
}());
export { ClassService };
//# sourceMappingURL=class.service.js.map